import UIIcon from '@/components/UI/UIIcon'
import UITag from '@/components/UI/UITag'

export function useTransComponents() {
  return {
    components: {
      tag: <UITag rounded='lighter' />,
      line: <div className='Line' />,
      swirl: (
        <span aria-hidden='true' className='Decoration inline-block relative w-[0.5em] h-[0.8em]'>
          <UIIcon
            className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/3 text-[110px] text-scarlet'
            icon='swirl'
          />
        </span>
      ),
      clover: (
        <span aria-hidden='true' className='Decoration inline-block relative w-[0.5em] h-[0.8em]'>
          <UIIcon
            className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/3 text-[110px] text-mid-blue'
            icon='clover'
          />
        </span>
      ),
      diamond: (
        <span aria-hidden='true' className='Decoration inline-block relative w-[0.5em] h-[0.8em]'>
          <UIIcon
            className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/3 text-[110px] text-coral'
            icon='diamond'
          />
        </span>
      ),
      explosion: (
        <span aria-hidden='true' className='Decoration inline-block relative w-[0.5em] h-[0.8em]'>
          <UIIcon
            className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/3 text-[110px] text-light-blue'
            icon='explosion'
          />
        </span>
      ),
      triangle: (
        <span aria-hidden='true' className='Decoration inline-block relative w-[0.5em] h-[0.8em]'>
          <UIIcon
            className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/3 text-[110px] text-scarlet'
            icon='triangle'
          />
        </span>
      ),
      circle: (
        <span aria-hidden='true' className='Decoration inline-block relative w-[0.5em] h-[0.8em]'>
          <UIIcon
            className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/3 text-[110px] text-mid-blue'
            icon='circle'
          />
        </span>
      ),
      doodle: (
        <span aria-hidden='true' className='Decoration inline-block relative w-[0.5em] h-[0.8em]'>
          <UIIcon
            className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/3 text-[110px] text-coral'
            icon='doodle'
          />
        </span>
      ),

      color: <em className='Color not-italic text-accent' />,
      strong: <strong className='Strong font-semibold' />,
      nowrap: <span className='whitespace-nowrap' />,

      good: <UIIcon className='text-64 md:text-128' icon='choiceGood' />,
      neutral: <UIIcon className='text-64 md:text-128' icon='choiceNeutral' />,
      bad: <UIIcon className='text-64 md:text-128' icon='choiceBad' />,

      name: <UITag variant='small' className='text-body-s' />,
      ul: <ul className='List list-disc list-outside pl-[1.4em]' />,
      li: <li className='ListItem' />,
      a: <a className='Link font-semibold underline hover:text-mid-blue' target='_blank' rel='noopener noreferrer' />,
    },
  }
}
